import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

export const useUpdateDPO = () => {
  const { authHeader } = useAuth();

  return useMutation((params: any) => {
    return axios.patch(
      `${env.verifyServiceUrl}user/dpo/${params.id}/`,
      params,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
